/* Graph of Life brand v1.1.0 · tokens.json */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import posthog from '@/lib/posthog';
import { reviewMailto, scopePath } from '@/data/siteConfig';

const track = (event, props) => {
  try {
    posthog.capture(event, props);
  } catch (e) {
    /* analytics must never block a CTA */
  }
};

export const ReviewCta = ({
  label = 'Scope a Review',
  location = 'unknown',
  variant = 'primary',
  testId,
  onClick,
}) => {
  const base =
    'gol-review-cta group inline-flex items-center justify-center gap-3 px-6 py-3.5 rounded-sm font-mono text-xs uppercase transition-colors duration-300';
  const styles =
    variant === 'primary'
      ? 'bg-teal-400 text-abyss-950 hover:bg-teal-300 hover:shadow-[0_0_34px_rgba(45,212,191,0.45)]'
      : 'border border-teal-500/40 text-teal-300 bg-teal-500/5 hover:bg-teal-500/15 hover:border-teal-400 hover:shadow-[0_0_26px_rgba(45,212,191,0.25)]';

  return (
    <Link
      to={scopePath}
      data-testid={testId}
      onClick={(event) => { track('review_cta_click', { location }); onClick?.(event); }}
      className={`${base} ${styles}`}
    >
      {label}
      <ArrowUpRight
        size={14}
        aria-hidden="true"
        className="shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
      />
    </Link>
  );
};

export const GhostLink = ({ to, href, children, testId, external = false, onClick }) => {
  const cls =
    'group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] text-teal-400 hover:text-sand-50 transition-colors duration-300 border-b border-teal-900 hover:border-teal-400 pb-1';
  if (external) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} onClick={onClick} className={cls}>
        {children}
        <ArrowUpRight
          size={12}
          aria-hidden="true"
          className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
        />
        <span className="sr-only">(opens an external site)</span>
      </a>
    );
  }
  return (
    <a href={to} data-testid={testId} onClick={onClick} className={cls}>
      {children}
    </a>
  );
};

export { track, reviewMailto };
